module.exports = __webpack_public_path__ + "img/200.24dfeff3.png";